'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdUpdate = function MdUpdate(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.9 13.4v7l5.7 3.5-1.1 2-7.1-4.3v-8.2h2.5z m14.1 3.5h-11.3l4.6-4.7c-4.6-4.6-12-4.7-16.5-0.2s-4.5 11.7 0 16.3 11.9 4.5 16.5 0c2.2-2.3 3.3-4.9 3.3-8.1h3.4c0 3.2-1.4 7.5-4.4 10.4-5.8 5.8-15.4 5.8-21.2 0s-5.9-15.1 0-20.9 15.2-5.8 21.1 0l4.5-4.7v11.9z' })
        )
    );
};

exports.default = MdUpdate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/update.js
// module id = 2897
// module chunks = 0